import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { arrayOf, bool, number, shape, string, array } from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import { getCurrentContent } from '../../../utils/ugc/getCurrentContent';
import { isFiverrChoice } from '../../../utils/fiverrChoice';
import Badge from '../Badge';
import Languages from '../Languages';
import Location from '../Location';
import { ExpertModal } from '../ExpertModal';

import './style.scss';

const ExpertInfo = ({
    isPro,
    countryCode,
    proficientLanguages,
    sellerName,
    oneLiner,
    translationFlag,
    className
}, {
    choiceEligibilities
}) => {
    const { queryParameters, abTests } = getContext();
    const fiverrChoice = isFiverrChoice({ queryParameters, abTests, choiceEligibilities });

    return (
        <div className={classNames(className, 'expert-info flex')}>
            <div className="expert-headline flex">
                <ExpertModal username={sellerName} translationFlag={translationFlag}>
                    <span className="pointer seller-name tbody-4 m-r-8 text-bold co-text-darkest flex">
                        {sellerName}
                    </span>
                </ExpertModal>
                {(isPro || fiverrChoice) && (
                    <Badge className="flex flex-items-center"
                        type={fiverrChoice ? Badge.TYPE.FIVERR_CHOICE : Badge.TYPE.PRO}/>
                )}
            </div>
            {oneLiner && <span className="one-liner co-text-darker m-t-8 m-b-8">
                {oneLiner}
            </span>}
            <div className="flex locale">
                <Location className="flex location m-r-16" countryCode={countryCode}/>
                <Languages className="languages flex m-r-16"
                    languages={proficientLanguages}/>
            </div>
        </div>
    );
};

ExpertInfo.propTypes = {
    isPro: bool,
    translationFlag: bool,
    countryCode: string,
    oneLiner: string,
    proficientLanguages: arrayOf(
        shape({
            name: string,
            level: number
        })
    ),
    sellerName: string
};

ExpertInfo.contextTypes = {
    choiceEligibilities: array
};

const mapStateToProps = ({ ugc }) => {
    const { sellerCard } = getCurrentContent({ ugc });

    return {
        oneLiner: sellerCard.oneLiner
    };
};

const ConnectedExpertInfo = connect(mapStateToProps)(ExpertInfo);

export { ExpertInfo };
export default ConnectedExpertInfo;
